import vTag from "./v-tag.vue";

export default Vue => {
  Vue.component("v-tag", vTag);
};
